import { apiFetch, withQuery } from '@/lib/api/client';
import type { Task, TaskEvent } from '@/types/api';

export function fetchTask(taskId: string): Promise<Task> {
  return apiFetch<Task>(`/tasks/${taskId}`);
}

export function fetchTaskEvents(taskId: string): Promise<{ items: TaskEvent[] }> {
  return apiFetch(`/tasks/${taskId}/events`);
}

/** A POST because it changes something. It used to be a side effect of the GET. */
export function markTaskRead(taskId: string): Promise<void> {
  return apiFetch(`/tasks/${taskId}/read`, { method: 'POST' });
}

export interface TaskSearchRequest {
  readonly q: string;
  /** Admin only — searches one person's cards instead of the company's. */
  readonly assigneeId?: string | undefined;
  readonly limit?: number | undefined;
}

export function searchTasks({ q, assigneeId, limit = 25 }: TaskSearchRequest): Promise<{ items: Task[] }> {
  return apiFetch(withQuery('/tasks', { q, assigneeId, limit }));
}
